import { find } from 'lodash/fp';

const contains = (string1, string2) => {
  const lowerCaseString = string1.toLowerCase();
  return lowerCaseString.includes(string2.toLowerCase());
};

const filterDoctorsByService = (doctors, selectedServiceId) => {
  if (selectedServiceId === 0) return doctors;
  return doctors.filter(
    d => d.Services.includes(selectedServiceId) || d.Services.length === 0,
  );
};

const filterDoctors = filterStr => (doctors, selected) => {
  if (!filterStr) return doctors;
  return doctors.filter(
    d =>
      contains(d.Name, filterStr) || (selected && contains(d.Name, selected)),
  );
};

const filterServices = (currentServiceFilter, services) => {
  if (!currentServiceFilter) return services;
  return services.filter(
    s =>
      contains(s.Name, currentServiceFilter),
  );
};

const matchAppointments = (id, appointments) =>
  find(({ PmsUserId }) => PmsUserId === id, appointments);

export { contains, filterDoctorsByService, filterDoctors, filterServices, matchAppointments };
